import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DatabaseCacheService } from '@app/data/cache/database-cache.service';
import { SHARED_IMPORTS } from 'src/app/shared/standalone-imports';
import { MANUAL_I18N } from './manual.i18n';

@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: SHARED_IMPORTS,
})
export class ManualComponent {
  private readonly dbCache = inject(DatabaseCacheService);

  protected readonly i18n = MANUAL_I18N;
  protected readonly selectedSectionId = this.dbCache.getSelectedSection()?.sectionId ?? '';
}
